module.exports = __webpack_public_path__ + "img/panjuedengji.344ed399.png";